import { Reveal, CountUp } from "./Reveal";
import { FAMILIES } from "@/lib/families";

/* Only verifiable, current facts are shown — no inflated claims. */
const STATS = [
    { value: 40, suffix: "+", label: "Years of industry expertise", decimals: 0 },
    { value: FAMILIES.length, suffix: "", label: "Product families under one roof", decimals: 0 },
    { value: 112, suffix: "", label: "Catalogue lines listed online", decimals: 0 },
    { value: 4, suffix: "", label: "Manufacturer price lists published", decimals: 0 },
];

export default function Stats() {
    return (
        <section className="relative border-b border-line hud-bg" data-testid="stats-band">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 md:py-20 grid grid-cols-2 lg:grid-cols-4 gap-10">
                {STATS.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.08}>
                        <div data-testid={`stat-${i}`} className="border-l-2 border-copper/40 pl-5">
                            <p className="font-display font-bold text-5xl md:text-6xl text-ink leading-none">
                                <CountUp value={s.value} decimals={s.decimals} />
                                <span className="text-copper">{s.suffix}</span>
                            </p>
                            <p className="mt-3 font-mono text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-dim">
                                {s.label}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
